import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin" : (loc.state?.from || "/"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="login-page">
      <h1 className="font-display font-black text-3xl tracking-tighter">{t("auth.loginTitle")}</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-5">
        <Field label={t("auth.email")} type="email" value={email} onChange={setEmail} testid="login-email" />
        <Field label={t("auth.password")} type="password" value={password} onChange={setPassword} testid="login-password" />
        <button type="submit" disabled={loading} className="btn-maroon w-full py-3 font-bold disabled:opacity-60" data-testid="login-submit">
          {loading ? t("checkout.processing") : t("auth.submit")}
        </button>
      </form>
      <div className="text-sm text-slate-500 mt-6">
        {t("auth.noAccount")}{" "}
        <Link to="/register" className="font-bold text-[#8D1B3D] hover:underline" data-testid="goto-register">
          {t("auth.signupCta")}
        </Link>
      </div>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, testid }) {
  return (
    <label className="block">
      <div className="label-mono text-slate-500 mb-1.5">{label}</div>
      <input
        type={type}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-slate-300 px-3 py-3 outline-none focus:border-[#8D1B3D] text-sm"
        data-testid={testid}
      />
    </label>
  );
}
